// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1P_B-","title":"FrontImage_title__oZ5lq"};